import React from "react";
import FlashAutoIcon from "@mui/icons-material/FlashAuto";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import {
    CompletionsRequestState,
    fetchAutocompletions,
} from "@Store/Reducers/completions";
import { useDispatch } from "react-redux";
import useSuggestedChoices from "@Hooks/useSuggestedChoices";
import { actions as completionActions } from "@Store/Reducers/completions";

const isValidQuestion = (question: string): boolean => {
    const regex = /^\s*[\w\s?',.$%"&!]+\?\s*$/;
    return regex.test(question);
};

const AutofillChoices: React.FC<{ question: string }> = ({ question }) => {
    const dispatch = useDispatch<any>();
    const [autocompletionStatus] = useSuggestedChoices();

    const handleAutofillChoices = () => {
        if (isLoading()) return; //avoid double clicking

        dispatch(fetchAutocompletions(question));

        dispatch(completionActions.setQuestion(question));
    };

    const isLoading = (): boolean =>
        autocompletionStatus === CompletionsRequestState.LOADING;

    return (
        <Tooltip title="Autofill choices" placement="right-start">
            <span>
                <IconButton
                    onClick={handleAutofillChoices}
                    disabled={!isValidQuestion(question)}
                    size="large"
                >
                    {isLoading() ? (
                        <CircularProgress size={16} />
                    ) : (
                        <FlashAutoIcon></FlashAutoIcon>
                    )}
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default React.memo(AutofillChoices);
